import { Link } from 'react-router-dom';

const INDUSTRIES = [
  'Restaurant', 'Medical & Clinic', 'Dental', 'Hair Salon',
  'General Contractor', 'Law Firm', 'Real Estate',
  'Currency Exchange', 'Other / Custom',
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <img src="/nb-logo.png" alt="NextBell" className="w-12 h-12 rounded-xl mb-3" data-testid="footer-logo" />
            <span className="font-heading font-semibold text-white text-lg block">NextBell</span>
            <p className="text-slate-500 text-xs mt-3 leading-relaxed">
              The AI receptionist that answers every call, books every appointment, and never sleeps.
            </p>
          </div>

          {/* Product */}
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold mb-3">Product</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/login" className="text-slate-400 hover:text-white transition-colors">Login</Link></li>
              <li><Link to="/signup" className="text-slate-400 hover:text-white transition-colors">Sign Up</Link></li>
              <li><a href="https://www.averoan.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">About Us</a></li>
              <li><Link to="/terms" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-terms-link">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Industries */}
          <div className="col-span-2 md:col-span-2">
            <p className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold mb-3">Industries we serve</p>
            <ul className="grid grid-cols-2 gap-y-2 gap-x-4 text-sm" data-testid="footer-industries">
              {INDUSTRIES.map(name => (
                <li key={name}>
                  <Link to="/signup" className="text-slate-400 hover:text-white transition-colors">{name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">&copy; 2026 NextBell. All rights reserved.</p>
          <a href="https://www.averoan.com" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-500 hover:text-slate-300 transition-colors" data-testid="footer-averoan-link">
            Powered by Averoan Technologies Inc.
          </a>
        </div>
      </div>
    </footer>
  );
}
